import process from 'process';

export const availableEnvironments = ['local', 'staging', 'production'] as const;
type Environment = (typeof availableEnvironments)[number];

let cachedVars: Map<string, string>;

export function getEnv(name: string): Environment | null | undefined {
    // @ts-expect-error process.browser is a webpack-specific property for browser detection
    if (process.browser) {
        if (!cachedVars) {
            cachedVars = varsFromDocumentMeta();
        }
        return cachedVars.get(name) as Environment | undefined;
    }
    return process.env[name] as Environment;
}

export function getEnvRequired(name: string): Environment {
    const env = getEnv(name);
    if (!env) {
        throw new Error('The following environment variable ' + name + ' is not defined');
    }
    return env;
}

function varsFromDocumentMeta(): Map<string, string> {
    const elements = document.querySelectorAll<HTMLMetaElement>('meta[name^="env:"]');
    return new Map(
        Array.from(elements, (meta: HTMLMetaElement) => [meta.name.slice(4), meta.content]),
    );
}
